import { inject, Injectable } from '@angular/core';
import { HomeState } from './home.state';
import { BannerLocation, BannersService } from '../../../services';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { mapToBannersItem } from '../utils/banners.util';

@Injectable()
export class BannersFacade {
  private readonly api = inject(BannersService);
  private readonly state = inject(HomeState);

  readonly banners = this.state.banners;
  readonly isLoading = this.state.isBannersLoading;

  fetchBanners(): void {
    this.state.setBannersLoading(true);

    this.api
      .fetchBanners(BannerLocation.HOME)
      .pipe(
        map((banners) => banners.map((b) => mapToBannersItem(b))),
        tap((banners) => this.state.setBanners(banners)),
        catchError(() => of([])),
        finalize(() => this.state.setBannersLoading(false))
      )
      .subscribe();
  }
}
